/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} A11y_Statement_Feedback_TextInputs */

const en_a11y_statement_feedback_text = /** @type {(inputs: A11y_Statement_Feedback_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you encounter barriers on our website, please contact us:`)
};

const de_a11y_statement_feedback_text = /** @type {(inputs: A11y_Statement_Feedback_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn Sie Barrieren auf unserer Webseite feststellen, kontaktieren Sie uns bitte:`)
};

const fr_a11y_statement_feedback_text = /** @type {(inputs: A11y_Statement_Feedback_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si vous rencontrez des obstacles sur notre site, veuillez nous contacter :`)
};

const es_a11y_statement_feedback_text = /** @type {(inputs: A11y_Statement_Feedback_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si encuentra barreras en nuestro sitio web, contactenos:`)
};

const it_a11y_statement_feedback_text = /** @type {(inputs: A11y_Statement_Feedback_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se incontri barriere sul nostro sito web, contattaci:`)
};

const nl_a11y_statement_feedback_text = /** @type {(inputs: A11y_Statement_Feedback_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als u barrières tegenkomt op onze website, neem dan contact met ons op:`)
};

const pl_a11y_statement_feedback_text = /** @type {(inputs: A11y_Statement_Feedback_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jesli napotkasz bariery na naszej stronie, skontaktuj sie z nami:`)
};

const fi_a11y_statement_feedback_text = /** @type {(inputs: A11y_Statement_Feedback_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jos kohtaat esteitä verkkosivustollamme, ota meihin yhteyttä:`)
};

const da_a11y_statement_feedback_text = /** @type {(inputs: A11y_Statement_Feedback_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvis du oplever barrierer pa vores hjemmeside, kontakt os venligst:`)
};

const sv_a11y_statement_feedback_text = /** @type {(inputs: A11y_Statement_Feedback_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om du stoter pa hinder pa var webbplats, kontakta oss:`)
};

/**
* | output |
* | --- |
* | "If you encounter barriers on our website, please contact us:" |
*
* @param {A11y_Statement_Feedback_TextInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const a11y_statement_feedback_text = /** @type {((inputs?: A11y_Statement_Feedback_TextInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<A11y_Statement_Feedback_TextInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_a11y_statement_feedback_text(inputs)
	if (locale === "fr") return fr_a11y_statement_feedback_text(inputs)
	if (locale === "es") return es_a11y_statement_feedback_text(inputs)
	if (locale === "it") return it_a11y_statement_feedback_text(inputs)
	if (locale === "nl") return nl_a11y_statement_feedback_text(inputs)
	if (locale === "pl") return pl_a11y_statement_feedback_text(inputs)
	if (locale === "fi") return fi_a11y_statement_feedback_text(inputs)
	if (locale === "da") return da_a11y_statement_feedback_text(inputs)
	if (locale === "sv") return sv_a11y_statement_feedback_text(inputs)
	return en_a11y_statement_feedback_text(inputs)
});